import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiPost } from "../../../api";
import "../../../App.css";
import "../styles/Register.css";

import studentRegister from "../../../images/student-register.png";

export default function Register({ goHome }) {
  const [firstName, setFirst] = useState("");
  const [lastName, setLast] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const passwordValid = {
    length: password.length >= 10 && password.length <= 20,
    letter: /[a-zA-Z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };
  const allValid = Object.values(passwordValid).every(Boolean);
  const passwordsMatch = confirm.length > 0 && password === confirm;

  const onCreate = async (e) => {
    e.preventDefault();
    setMsg("");
    setIsSuccess(false);
    setLoading(true);
    if (!allValid) {
      setMsg("Password does not meet requirements.");
      setIsSuccess(false);
      setLoading(false);
      return;
    }
    if (!passwordsMatch) {
      setMsg("Passwords do not match.");
      setIsSuccess(false);
      setLoading(false);
      return;
    }

    try {
      const res = await apiPost("/auth/register", {
        firstName,
        lastName,
        email,
        password,
      });
      setMsg(
        res.message +
          (res.devVerifyUrl ? `  Dev link: ${res.devVerifyUrl}` : "")
      );
      setIsSuccess(true);
    } catch (err) {
      setMsg(err.message);
      setIsSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      {/* ✅ Illustration */}
      <img
        src={studentRegister}
        alt="Register illustration"
        className="register-illustration"
      />
      <div className="register-box">
        <h1 className="register-title">Register</h1>

        <form onSubmit={onCreate} className="register-form">
          <label>First Name</label>
          <input value={firstName} onChange={(e) => setFirst(e.target.value)} />

          <label>Last Name</label>
          <input value={lastName} onChange={(e) => setLast(e.target.value)} />

          <label>Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="yourname@my.yorku.ca"
          />

          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPass(e.target.value)}
          />

          {/* Password requirements */}
          <ul className="password-checks">
            <li className={passwordValid.length ? "ok" : "bad"}>
              {passwordValid.length ? "✔" : "✖"} 10–20 characters
            </li>
            <li className={passwordValid.letter ? "ok" : "bad"}>
              {passwordValid.letter ? "✔" : "✖"} At least one letter
            </li>
            <li className={passwordValid.number ? "ok" : "bad"}>
              {passwordValid.number ? "✔" : "✖"} At least one number
            </li>
            <li className={passwordValid.special ? "ok" : "bad"}>
              {passwordValid.special ? "✔" : "✖"} At least one special character
              (e.g. !@#$%)
            </li>
          </ul>

          <label>Verify Password</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          {confirm.length > 0 && (
            <p className={`match-msg ${passwordsMatch ? "ok" : "bad"}`}>
              {passwordsMatch
                ? "Passwords match ✔"
                : "Passwords do not match ✖"}
            </p>
          )}

          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Register"}
          </button>
        </form>

        {msg && (
          <p className={`msg ${isSuccess ? "success" : "error"}`}>{msg}</p>
        )}

        <div className="register-links">
          <p>
            Already have an account?{" "}
            <Link to="/auth/react/signin" className="link">
              Sign in
            </Link>
          </p>
          <p>
            Need a new verification email?{" "}
            <Link to="/auth/react/resend-verification" className="link">
              Resend it
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
